// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2Nqid","title":"FrontImage_title__1Xf7U"};